import React, { FC, ReactElement } from "react";

import { useMsal } from "@azure/msal-react";

import { Logout } from "@mui/icons-material";
import { Grid, Typography,Tooltip, } from "@mui/material";
import { useIdleTimer } from "../IdleTimer";

const UserAvatar: FC<any> = (): ReactElement => {
  const { instance, accounts } = useMsal();

  const currentAccount = accounts[0]?.name;

  const refreshPage = () => {
    handleLogout("redirect");
  };

  const handleLogout = (logoutType: string) => {
    if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "",
      });
    }
  };
  useIdleTimer(refreshPage, 90 * 60 * 1000);

  return (
    <Grid
      id="logout"
      container
      justifyContent="space-between"
      sx={{
        p: 2,
      }}
    >
      <Typography>{currentAccount}</Typography>
      <Tooltip title="Logout">
      <Logout
        color="primary"
        onClick={() => handleLogout("redirect")}
        sx={{
          cursor: "pointer",
        }}
      />
      </Tooltip>
    </Grid>
  );
};

export default UserAvatar;
